module.exports = __webpack_public_path__ + "img/cn-bg.3ae78f14.jpg";